import { styled } from '@slal/ui';
import { Checkbox } from '@slal/ui/forms';
import { breakpointUp } from '@slal/ui/helpers';

export const StyledCheckbox = styled(Checkbox)`
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    appearance: none;
    -webkit-appearance: none;
    background-color: ${({ theme }) => theme.colors.neutral__light__00};
    border: 2px solid ${({ theme }) => theme.colors.neutral__light__60};
    border-radius: 4px;
    position: relative;
    cursor: pointer;

    &:checked {
        background-color: ${({ theme }) => theme.colors.input.checkbox.accentColor};
        border: none;
    }

    &:checked::after {
        content: '';
        position: absolute;
        top: 45%;
        left: 50%;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 1px 1px 0;
        transform: translate(-50%, -50%) rotate(45deg);
    }

    ${breakpointUp.lg`
          width: 32px;
          height: 32px;
          min-width: 32px;
          min-height: 32px;

          &:checked::after {
              width: 8px;
              height: 16px;
          }
      `}
`;
